<template>
  <v-content>
    <v-container grid-list-bg class="pb-0" style="background-color:#FFFFFF">
      <template>
       <v-card>
                  <v-card-title>
                    <span class="headline">Guardar Archivo</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                      
                        <v-flex xs12 sm12 d-flex>
                          <form enctype="multipart/form-data">
                            <input
                              type="file"
                              name="file"
                              ref="files"
                              multiple
                              v-on:change="fileChange($event)"
                            />
                          </form>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                   
                    <v-btn color="blue darken-1" text @click="uploadArchivo">Guardar</v-btn>
                     <v-btn color="blue darken-1" text @click="upload">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
       
      </template>
      
    </v-container>
  </v-content>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import axunidad from "axios";
import { async } from "q";

// console.log(jsPDF);

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  data: () => ({
  
    files: "",
   
 
   
  
 
  }),

  computed: {
  },

  watch: {
    },
   


  created() {

  },

  methods: {
  
    //carga de archivos//////////////////////////////////////////////////////////////////////////////////////////////
    fileChange(event) {
      console.log(event.target.files[0]);
       if (event.target.files[0].size > 14 * 1024) {
      
        alert('el archivo no puede ser tan grande');
        return;
      }
      this.files = event.target.files[0];
    },

    async upload() {
      let self = this;
      console.log("edite cargar", this.editedItem);
      let formData = new FormData();

      formData.append("files", this.files);
      formData.append("jsonString", JSON.stringify(this.editedArchivos));
      //////////////////////////
      console.log(formData);
      var response = await axunidad
        .post(`https://enjambrec.ugto.mx/RG/Transparencia/darchivo/`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
        //  alert(res);
        var llenapdf=res.data;
        console.log("guardado" ,llenapdf);
          // alert("No Olvides descargar Tu comprobante");
          // this.close3();
            console.log("mandar a pdf",llenapdf);
         self.emailcomprobante(llenapdf);

        });
  
      console.log(response);
    },

    async uploadArchivo() {
          this.dataArchivo = {
              IdDatosMovilidadFk :3,
       
      };
      let formData = new FormData();
console.log(this.dataArchivo);
      formData.append("files", this.files);
      formData.append("jsonString", JSON.stringify(this.dataArchivo));
      //////////////////////////
      console.log(formData);
      var response = await axunidad
        .post(`https://enjambrec.ugto.mx/RG/Transparencia/ArchivoSubir/`, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(res => {
          console.log(res);
          alert(res.status);
        })
        .catch(error => {
          alert(error);
        });
      // eslint-disable-next-line no-console
      console.log(response);
    },
 },


};
</script>